export const infoItems = [
  {
    label: 'Номер счета',
    field: 'account_number',
    isCopy: true,
  },
  {
    label: 'БИК',
    field: 'bic',
    isCopy: true,
  },
  {
    label: 'Банк получателя',
    field: 'bank.name',
    isCopy: false,
  },
  {
    label: 'Получатель',
    field: 'name',
    isCopy: false,
  },
  {
    label: 'Назначение платежа',
    field: 'purpose',
    isCopy: true,
  },
  {
    label: 'Корреспондентский счет',
    field: 'corresp_acc',
    isCopy: true,
  },
  {
    label: 'ИНН',
    field: 'payee_inn',
    isCopy: true,
  },
];

export const sberUzbekistanInfoItems = [
  {
    label: 'Номер телефона',
    field: 'phone_number',
    isCopy: true,
  },
  {
    label: 'Банк получателя',
    field: 'bank.name',
    isCopy: false,
  },
  {
    label: 'Получатель',
    field: 'fio',
    isCopy: true,
  },
];
